import React from 'react';
import { Box, Button, InputBase } from '@mui/material';
import { Colors } from '../../../utils/theme';
import { Recipient } from './RecipientsStep';
import { Mail, PermContactCalendar, Person, RemoveCircleRounded } from '@mui/icons-material';
import CSS from 'csstype';
import './index.css';

interface IProps {
  recipient: Recipient;
  removeFromList: (value: Recipient) => void;
}

const iconStyle: CSS.Properties = {
  marginRight: '1%',
  marginBottom: '0.4%',
  color: Colors.main,
  height: '16px'
};

const textStyle: CSS.Properties = {
  WebkitTextFillColor: Colors.main,
  fontSize: '14px',
  fontFamily: 'Overpass'
};

const RecipientItem: React.FunctionComponent<IProps> = ({ recipient, removeFromList }: IProps) => {
  const { isNew } = recipient;

  return (
    <Box
      className="recipient-item"
      sx={{
        background: isNew ? Colors.lightBlue : Colors.white,
        boxShadow: isNew ? '' : '0px 3px 20px #12497F12'
      }}
    >
      <InputBase
        id={'contact-' + recipient.id + '-fullname'}
        data-testid={'contact-' + recipient.id + '-fullname'}
        value={recipient.fullName}
        disabled
        fullWidth
        startAdornment={<Person style={{ ...iconStyle, width: '14px' }} />}
        inputProps={{ style: textStyle }}
      />
      <InputBase
        id={'contact-' + recipient.id + '-titleInternal'}
        data-testid={'contact-' + recipient.id + '-titleInternal'}
        value={recipient.titleInternal.name}
        disabled
        fullWidth
        startAdornment={<PermContactCalendar style={{ ...iconStyle, width: '12px' }} />}
        inputProps={{ style: textStyle }}
      />
      <InputBase
        id={'contact-' + recipient.id + '-email'}
        data-testid={'contact-' + recipient.id + '-email'}
        value={recipient.email}
        disabled
        fullWidth
        startAdornment={<Mail style={{ ...iconStyle, width: '16px' }} />}
        inputProps={{ style: textStyle }}
      />
      <Button onClick={() => removeFromList(recipient)}>
        <RemoveCircleRounded sx={{ color: Colors.skyBlue, width: '20px', height: '21px' }} />
      </Button>
    </Box>
  );
};

export default RecipientItem;
